// services/api.js
import axios from "axios";
import BASE_URL from "./baseURL";

export const getTraineeProjectsByToken = async (TraineeToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeProjectsByToken`, { 
      TraineeToken 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee projects:", error);
    throw error;
  }
};

export const getTraineeProjectFeatures = async (TraineeToken, traineeProjectToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeProjectFeatures`, { 
      TraineeToken,
      traineeProjectToken
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching project features:", error);
    throw error;
  }
};

export const addProjectTask = async (taskData) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/addProjectTask`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error adding project task:", error);
    throw error;
  }
};

export const updateTraineeTaskStatus = async (TraineeTaskToken, statusCode) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/updateTraineeTaskStatus`, { 
      TraineeTaskToken,
      statusCode
    });
    return response.data;
  } catch (error) {
    console.error("Error updating task status:", error);
    throw error;
  }
};

// services/api.js
export const getTraineeFeatureTasks = async (taskData) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeFeatureTasks`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error fetching feature tasks:", error);
    throw error;
  }
};
export const getTraineeAttendance = async (TraineeToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeAttendance`, { 
      TraineeToken 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee attendance:", error);
    throw error;
  }
};

// services/api.js
export const getTraineeDashboard = async (TraineeToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeDashboard`, { 
      TraineeToken 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee dashboard:", error);
    throw error;
  }
};


// Profile APIs
export const getTraineeProfile = async (TraineeToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeProfile`, { 
      TraineeToken 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee profile:", error);
    throw error;
  }
};

export const updateTraineeDetails = async (profileData) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/updateTraineeDetails`, profileData);
    return response.data;
  } catch (error) {
    console.error("Error updating trainee profile:", error);
    throw error;
  }
};

// services/api.js
export const getTraineeBatchDetails = async (TraineeToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeBatchDetails`, { 
      TraineeToken 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee batch details:", error);
    throw error;
  }
};


// services/api.js

// Edit project task
export const editProjectTask = async (taskData) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/editProjectTask`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error editing project task:", error);
    throw error;
  }
};

// Delete project task
export const deleteProjectTask = async (traineeToken, TraineeTaskToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/deleteProjectTask`, {
      traineeToken,
      TraineeTaskToken
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting project task:", error);
    throw error;
  }
};